import { useMutation } from '@apollo/client';
import { Modal } from 'antd';
import React from 'react';
import { DELETE_TRAILER } from '../graphql/Mutation';

const DeleteModal = ({
  showModal,
  setShowModal,
  deleteData,
  refetch,
  setDeleteData
}) => {
  const [deleteTrailer, { loading }] = useMutation(DELETE_TRAILER, {
    onError() {}
  });

  const handleCancel = () => {
    setShowModal(false);
    setDeleteData();
  };

  const handleOk = async () => {
    const response = await deleteTrailer({
      variables: {
        where: {
          id: deleteData?.id
        }
      }
    });
    if (response) {
      setShowModal(false);
      refetch();
    }
  };

  return (
    <Modal
      visible={showModal}
      onCancel={handleCancel}
      okText="Yes, Delete"
      cancelText="No, Cancel"
      centered
      title="Delete Trailer"
      okButtonProps={{ danger: true }}
      onOk={handleOk}
      confirmLoading={loading}
    >
      <h3>Are you sure you want to delete trailer {deleteData?.name} ? </h3>
    </Modal>
  );
};

export default DeleteModal;
